const NotFoundModule = () => {
  return <div className="container mx-auto">Route not found</div>;
};

export default NotFoundModule;
